import * as Yup from "yup";

const ProposicaoTramitacaoCreateSchema = Yup.object({
    situacao: Yup.string().required({ name: "situacao", err: "Campo com preenchimento obrigatório" }),
    descricao: Yup.string().required({ name: "descricao", err: "Campo com preenchimento obrigatório" }),
});


export default ProposicaoTramitacaoCreateSchema;